import ComponentManager from '@/Management/ComponentManager';
import Message from '@/Messages/Message';

export default class FilterChipsChangedMessage extends Message {

    public action: 'ADD' | 'REMOVE';

    public listViewPdoId: string;

    public chipName: string;

    public isPublicChip: boolean;

    public chipsControlId: string;

    public constructor(protected params: any) {
        super(params);

        this.action = this.paramOrDefault(params.action, '');
        this.listViewPdoId = this.paramOrDefault(params.listViewPdoId, '-1');
        this.chipName = this.paramOrDefault(params.chipName, '');
        this.isPublicChip = this.paramOrDefault(params.isPublicChip, false);
        this.chipsControlId = this.paramOrDefault(params.chipsControlId, '');
    }
}

ComponentManager.setMessage('FilterChipsChanged', FilterChipsChangedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');